interface LevelPickerProps {
	// The topic's difficulty steps, in order — Topic.levels straight from
	// GET /api/topics.
	levels: string[]
	// The chosen step, 1-based, matching rounds.level.
	level: number
	onChange: (level: number) => void
}

// The "How hard?" control inside a topic modal, shared by Home, KidHome and
// the friends page so the dialogs can never drift apart. A topic with fewer
// than two steps has nothing to choose, so it renders nothing at all rather
// than a radio group with one option — which is also why callers can drop it
// in unconditionally.
export function LevelPicker({ levels, level, onChange }: LevelPickerProps) {
	if (levels.length < 2) return null
	return (
		<fieldset class="stack gap-2">
			<legend class="eyebrow">How hard?</legend>
			<div class="flex wrap gap-3">
				{levels.map((name, i) => (
					<label class="check" key={name}>
						<input
							type="radio"
							name="level"
							checked={level === i + 1}
							onChange={() => onChange(i + 1)}
						/>
						{name}
					</label>
				))}
			</div>
		</fieldset>
	)
}
